import { Alert, AlertTitle } from '@mui/material';
import React from 'react'

interface Props {
  errors: any[]
}

export const ErrorExplanation: React.FC<Props> = ({errors}) => {
  return (
    <>
      {errors && errors.length > 0 && (
        <div id="error_explanation">
          <Alert severity="error">
            <AlertTitle>Error</AlertTitle>
            {errors.map((e, idx) => (
              <div key={idx}>{e}</div>
            ))}
          </Alert>
        </div>
      )}
    </>
  )
}
